var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getInfor && _vm.isMobile === false)?_c('PCDetail',{key:_vm.id,attrs:{"infor":_vm.infor}}):(_vm.getInfor && _vm.isMobile)?_c('MobDetail',{key:_vm.id,attrs:{"infor":_vm.infor}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }